import { useEffect, useState } from 'react'

import { customerAbandonmentAvailable } from './customer-abandonment'

import type { CheckoutSession } from '../api/checkout-session-types'

// 等待阈值仅结束遮罩，不代表支付失效或允许跳过后端核验。
export function useCustomerAbandonment(session: CheckoutSession | null, processing: boolean) {
  const [waitElapsed, setWaitElapsed] = useState(false)
  const available = customerAbandonmentAvailable(session)
  useEffect(() => {
    setWaitElapsed(false)
    if (!processing || !available) return
    const timer = window.setTimeout(() => setWaitElapsed(true), 30_000)
    return () => window.clearTimeout(timer)
  }, [session?.checkout_session_no, available, processing])
  return {
    available,
    canRestart: Boolean(available && (!processing || waitElapsed)),
    waitElapsed,
  }
}
